import { tabProps } from "@/utils/globalPropsTypes";
import { DatePicker, Form, Input, InputNumber, Radio, Select, Switch } from "antd";
import React from "react";
import { Col, Row } from "react-bootstrap";

const { RangePicker } = DatePicker;
function TimeFrameTab({ editItem, setEditItem, form }) {
  const {
    xAxis,
    intervalTime,
    lineIntervalTime,
    barIntervalTime,
    lastXDays,
    component,
    lineXAxis,
    barXAxis,
    barLastXDays,
    lineLastXDays,
  } = editItem;
  return (
    <>
      {component === "comboBar" ? (
        <>
          {/* line */}
          <div>
            <div className="mb-2 fw-bold"> Line Chart: </div>
            <Row>
              <Col xs={6}>
                <Form.Item label="Select Interval" name="lineIntervalTime">
                  <Select
                    showSearch
                    onChange={(value) => {
                      if (!value) {
                        setEditItem((pre) => ({ ...pre, lineOperator: undefined, lineIntervalValue: undefined }));
                        form.setFieldsValue({ lineOperator: undefined, lineIntervalValue: undefined });
                      }
                    }}
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    maxTagCount="responsive"
                    placeholder="Select Interval"
                    options={[
                      { label: "Real Time", value: "" },
                      { label: "Minute", value: 1 },
                      { label: "Hour", value: 60 },
                      { label: "Day", value: 1440 },
                      { label: "Monthly", value: 43830 },
                      { label: "Yearly", value: 525960 },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col xs={6}>
                {lineIntervalTime && (
                  <Form.Item label="Interval Value" name="lineIntervalValue">
                    <InputNumber className="w-100" controls={false} placeholder="Enter Value" />
                  </Form.Item>
                )}
              </Col>
            </Row>

            <Form.Item label="Select Time Period" name="lineXAxis">
              <Radio.Group className="d-flex">
                <Radio.Button className="w-100 text-center" value="day">
                  Daily
                </Radio.Button>
                <Radio.Button className="w-100 text-center" value="week">
                  Weekly
                </Radio.Button>
                <Radio.Button className="w-100 text-center" value="month">
                  Monthly
                </Radio.Button>
                <Radio.Button className="w-100 text-center" value="year">
                  Yearly
                </Radio.Button>
                <Radio.Button className="w-100 text-center" value="custom">
                  Custom
                </Radio.Button>
              </Radio.Group>
            </Form.Item>

            {["custom"].includes(lineXAxis) && (
              <div>
                <Form.Item
                  layout="horizontal"
                  label="Last X Day"
                  name="lineLastXDays"
                  colon={false}
                  className="right-label mb-0"
                >
                  <Switch />
                </Form.Item>
                {lineLastXDays ? (
                  <Form.Item label="Select Time" name="lineLastXDaysValue" rules={[{ required: true }]}>
                    <Input type="number" placeholder="Input Last X Days Number" />
                  </Form.Item>
                ) : (
                  <Form.Item label="Select Time" name="lineTimeRange">
                    <RangePicker showTime />
                  </Form.Item>
                )}
              </div>
            )}

            {!!lineIntervalTime && (
              <Form.Item label="Select Operator" name="lineOperator">
                <Radio.Group>
                  <Radio value="max">Maximum</Radio>
                  <Radio value="min">Minimum</Radio>
                  <Radio value="avg">Average</Radio>
                  <Radio value="sum">Sum</Radio>
                </Radio.Group>
              </Form.Item>
            )}
          </div>

          {/* bar */}
          <div>
            <div className="mb-2 mt-5 fw-bold"> Bar Chart: </div>
            <Row>
              <Col xs={6}>
                <Form.Item label="Select Interval" name="barIntervalTime">
                  <Select
                    showSearch
                    onChange={(value) => {
                      if (!value) {
                        setEditItem((pre) => ({ ...pre, barOperator: undefined, barIntervalValue: undefined }));
                        form.setFieldsValue({ barOperator: undefined, barIntervalValue: undefined });
                      }
                    }}
                    filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    maxTagCount="responsive"
                    placeholder="Select Interval"
                    options={[
                      { label: "Real Time", value: "" },
                      { label: "Minute", value: 1 },
                      { label: "Hour", value: 60 },
                      { label: "Day", value: 1440 },
                      { label: "Monthly", value: 43830 },
                      { label: "Yearly", value: 525960 },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col xs={6}>
                {barIntervalTime && (
                  <Form.Item label="Interval Value" name="barIntervalValue">
                    <InputNumber className="w-100" controls={false} placeholder="Enter Value" />
                  </Form.Item>
                )}
              </Col>
            </Row>

            <Form.Item label="Select Time Period" name="barXAxis">
              <Radio.Group className="d-flex">
                <Radio.Button className="w-100 text-center" value="day">
                  Daily
                </Radio.Button>
                <Radio.Button className="w-100 text-center" value="week">
                  Weekly
                </Radio.Button>
                <Radio.Button className="w-100 text-center" value="month">
                  Monthly
                </Radio.Button>
                <Radio.Button className="w-100 text-center" value="year">
                  Yearly
                </Radio.Button>
                <Radio.Button className="w-100 text-center" value="custom">
                  Custom
                </Radio.Button>
              </Radio.Group>
            </Form.Item>

            {["custom"].includes(barXAxis) && (
              <div>
                <Form.Item
                  layout="horizontal"
                  label="Last X Day"
                  name="barLastXDays"
                  colon={false}
                  className="right-label mb-0"
                >
                  <Switch />
                </Form.Item>
                {barLastXDays ? (
                  <Form.Item label="Select Time" name="barLastXDaysValue" rules={[{ required: true }]}>
                    <Input type="number" placeholder="Input Last X Days Number" />
                  </Form.Item>
                ) : (
                  <Form.Item label="Select Time" name="barTimeRange">
                    <RangePicker showTime />
                  </Form.Item>
                )}
              </div>
            )}

            {!!barIntervalTime && (
              <Form.Item label="Select Operator" name="barOperator">
                <Radio.Group>
                  {/* {!["bar"].includes(component) && <Radio value="">Real Time</Radio>} */}
                  <Radio value="max">Maximum</Radio>
                  <Radio value="min">Minimum</Radio>
                  <Radio value="avg">Average</Radio>
                  <Radio value="sum">Sum</Radio>
                </Radio.Group>
              </Form.Item>
            )}
          </div>
        </>
      ) : (
        <>
          <Row>
            <Col xs={6}>
              <Form.Item label="Select Interval" name="intervalTime">
                <Select
                  showSearch
                  onChange={(value) => {
                    if (!value) {
                      setEditItem((pre) => ({ ...pre, operator: undefined, intervalValue: undefined }));
                      form.setFieldsValue({ operator: undefined, intervalValue: undefined });
                    }
                  }}
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  maxTagCount="responsive"
                  placeholder="Select Interval"
                  options={[
                    { label: "Real Time", value: "" },
                    { label: "Minute", value: 1 },
                    { label: "Hour", value: 60 },
                    { label: "Day", value: 1440 },
                    { label: "Monthly", value: 43830 },
                    { label: "Yearly", value: 525960 },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={6}>
              {intervalTime && (
                <Form.Item label="Interval Value" name="intervalValue">
                  <InputNumber className="w-100" controls={false} placeholder="Enter Value" />
                </Form.Item>
              )}
            </Col>
          </Row>

          <Form.Item label="Select Time Period" name="xAxis">
            <Radio.Group className="d-flex">
              <Radio.Button className="w-100 text-center" value="day">
                Daily
              </Radio.Button>
              <Radio.Button className="w-100 text-center" value="week">
                Weekly
              </Radio.Button>
              <Radio.Button className="w-100 text-center" value="month">
                Monthly
              </Radio.Button>
              <Radio.Button className="w-100 text-center" value="year">
                Yearly
              </Radio.Button>
              <Radio.Button className="w-100 text-center" value="custom">
                Custom
              </Radio.Button>
            </Radio.Group>
          </Form.Item>

          {["custom"].includes(xAxis) && (
            <div>
              <Form.Item
                layout="horizontal"
                label="Last X Day"
                name="lastXDays"
                colon={false}
                className="right-label mb-0"
              >
                <Switch />
              </Form.Item>
              {lastXDays ? (
                <Form.Item label="Select Time" name="lastXDaysValue" rules={[{ required: true }]}>
                  <Input type="number" placeholder="Input Last X Days Number" />
                </Form.Item>
              ) : (
                <Form.Item label="Select Time" name="timeRange">
                  <RangePicker showTime />
                </Form.Item>
              )}
            </div>
          )}

          {/* {["bar", "line", "pie", "tank"].includes(component) && ( */}
          {!!intervalTime && (
            <Form.Item label="Select Operator" name="operator">
              <Radio.Group>
                {/* {!["bar"].includes(component) && <Radio value="">Real Time</Radio>} */}
                <Radio value="max">Maximum</Radio>
                <Radio value="min">Minimum</Radio>
                <Radio value="avg">Average</Radio>
                <Radio value="sum">Sum</Radio>
              </Radio.Group>
            </Form.Item>
          )}
          {/* )} */}
        </>
      )}
    </>
  );
}

export default TimeFrameTab;

TimeFrameTab.propTypes = tabProps;
